
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { categoriesModule, sectorsModule } from '../store';
import Category from '../models/Category';
import Sector from '../models/Sector';

@Component({ components: {} })
export default class extends Vue {
  @Prop([Object, String]) readonly category!: Category | string;

  get catId() {
    const { category } = this;
    if (typeof category === 'string') {
      return category;
    }
    return category?.id;
  }

  get isPlainCategory() {
    const { category } = this;
    if (typeof category === 'string') {
      return true;
    }
    return !category?.name || !category?.sector;
  }

  get isPlainSector() {
    const { sector } = this.cat || {};
    return !sector?.name;
  }

  get cat(): Category | undefined {
    if (!this.isPlainCategory) {
      return this.category as Category;
    }
    return categoriesModule.find(this.catId || '');
  }

  get sector(): Sector | undefined {
    const { id } = this.cat?.sector || {};
    return sectorsModule.find(id || '');
  }

  @Watch('catId', { immediate: true })
  onCategoryChange() {
    if (this.isPlainCategory) {
      categoriesModule.fetchItemsIfNeeded();
      if (this.isPlainSector) {
        sectorsModule.fetchItemsIfNeeded();
      }
    }
  }
}
